import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import getOutcomesOptions from 'src/common/utils/Outcomes/utils/getOutcomesOptions';

const SKELETON_MARGIN_TOP = { marginTop: 10 };

const SkeletonFields = ({
  outcomes,
  resolvedValue,
}) => (
  <>
    <Skeleton height={30} width={200} style={SKELETON_MARGIN_TOP} />
    {getOutcomesOptions(outcomes, resolvedValue).map((outcome) => (
      <Skeleton
        key={outcome.value || outcome.id || outcome.label}
        height={25}
        width={300}
        style={SKELETON_MARGIN_TOP}
      />
    ))}
    <Skeleton height={30} width={200} style={{ marginTop: 30 }} />
    <Skeleton height={100} width={500} style={SKELETON_MARGIN_TOP} />
    <Skeleton height={30} width={200} style={{ marginTop: 30 }} />
  </>
);

SkeletonFields.propTypes = {
  outcomes: PropTypes.array.isRequired,
  resolvedValue: PropTypes.string,
};

SkeletonFields.defaultProps = {
  resolvedValue: undefined,
};

export default SkeletonFields;
